export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14223.b29d3705.jpg";